"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTripRoute = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let CustomTripRoute = class CustomTripRoute {
    routeId;
    originLocationName;
    destinationLocationName;
    originLocationId;
    destinationLocationId;
    originLocationMachineName;
    destinationLocationMachineName;
    isOtherDirection;
    pricingCurrency = legacy_enums_1.Currency.Euro;
    isAirportTransfer;
};
exports.CustomTripRoute = CustomTripRoute;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "routeId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "originLocationName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "destinationLocationName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "originLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "destinationLocationId", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "originLocationMachineName", void 0);
__decorate([
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CustomTripRoute.prototype, "destinationLocationMachineName", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CustomTripRoute.prototype, "isOtherDirection", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CustomTripRoute.prototype, "pricingCurrency", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], CustomTripRoute.prototype, "isAirportTransfer", void 0);
exports.CustomTripRoute = CustomTripRoute = __decorate([
    (0, type_graphql_1.ObjectType)("CustomTripRoute")
], CustomTripRoute);
//# sourceMappingURL=CustomTripRoute.js.map